#import "../fragments/event-fragment-full.graphql"

query GetChangeLogEntry($id: ID!) {
    event(entityId: $id) {
        ...EventFragmentFull
    }
}
